import React, { useEffect, useState } from 'react';

//react-redux
import { useSelector, connect, useDispatch } from 'react-redux';

//routing
import { Link } from 'react-router-dom';

import arraySort from 'array-sort';

//action
import { getRedeem } from '../../../store/redeem/action';
import { getSetting } from '../../../store/setting/action';

//MUI
import { TablePagination } from '@mui/material';

//dayjs
import dayjs from 'dayjs';
import { getAgencyRedeem } from '../../../store/agenyRedeem/action';
import Pagination from '../../../pages/Pagination';

const TablePaginationActions = React.lazy(() => import('../TablePagination'));

const AcceptedRedeemTable = (props) => {
  const dispatch = useDispatch();


  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [coinSort, setCoinSort] = useState(true);
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    dispatch(getSetting());
    // dispatch(getAgencyRedeem("accept", activePage, rowsPerPage, search));
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getAgencyRedeem('accept', activePage, rowsPerPage, search));
    }, 100);
    return () => clearTimeout(timeout);
  }, [activePage, rowsPerPage]);
  // useEffect(()=>{
  //   dispatch(getAgencyRedeem("accept", activePage, rowsPerPage, search));
  // },[activePage ,rowsPerPage ])

  const redeem = useSelector((state) => state.agencyRedeem.agencyRedeem);
  const setting = useSelector((state) => state.setting.setting);

  useEffect(() => {
    setData(redeem.data);
  }, [redeem]);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    // dispatch(getAgencyRedeem("accept" , pageNumber , rowsPerPage ,search ));
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
    // dispatch(getAgencyRedeem("accept" , activePage , value ,search ));
  };

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase()
      ? e.target.value.trim().toUpperCase()
      : e.target.value.trim();
    if (value) {
      const data = redeem.filter((data) => {
        return (
          data?.userId?.name?.toUpperCase()?.indexOf(value) > -1 ||
          data?.paymentGateway?.toUpperCase()?.indexOf(value) > -1 ||
          data?.description?.toUpperCase()?.indexOf(value) > -1 ||
          data?.rCoin?.toString()?.indexOf(value) > -1
        );
      });
      setData(data);
    } else {
      return setData(redeem);
    }
  };

  const handleCoinSort = () => {
    setCoinSort(!coinSort);
    arraySort(data, 'rCoin', { reverse: coinSort });
  };

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left"></div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right">
                  <form action="">
                    <div className="input-group mb-3 border rounded-pill">
                      <div className="input-group-prepend border-0">
                        <div id="button-addon4" className="btn text-danger">
                          <i className="fas fa-search mt-2"></i>
                        </div>
                      </div>
                      <input
                        type="search"
                        placeholder="What're you searching for?"
                        aria-describedby="button-addon4"
                        className="form-control bg-none border-0 rounded-pill searchBar"
                        // onChange={handleSearch}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            dispatch(
                              getAgencyRedeem(
                                'accept',
                                activePage,
                                rowsPerPage,
                                search
                              )
                            );
                            setActivePage(1);
                          }
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="card-body card-overflow">
              {/* <div className="d-sm-flex align-items-center justify-content-between mb-4"></div> */}

              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Agency Name</th>
                    <th>Agency Code</th>
                    {/* <th>Payment Gateway</th> */}
                    <th>Description</th>
                    <th onClick={handleCoinSort} style={{ cursor: 'pointer' }}>
                      RCoin {coinSort ? ' ▼' : ' ▲'}
                    </th>
                    <th>

                      Amount({setting.currency?.symbol || '$'})
                    </th>
                    <th>Accepted date</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    (rowsPerPage > 0
                      ? data?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : data
                    ).map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.agency?.name}</td>
                          <td>{data.agency?.agencyCode}</td>

                          {/* <td>{data.paymentGateway}</td> */}

                          <td>{data.description}</td>
                          <td className="text-danger">
                            <div className='d-flex align-items-center justify-content-center gap-1'>
                              <span>
                                <img src="/rcoin.webp" alt="rcoin" height="20px" width="20px" />
                              </span>
                              <span>
                                {data?.rCoin ? data?.rCoin : '0'}
                              </span>
                            </div>
                          </td>
                          <td>
                            {(data.rCoin / setting.rCoinForCashOut).toFixed(2)} {setting.currency?.symbol || '$'}
                          </td>
                          <td>
                            {dayjs(data.updatedAt).format('DD MMM, YYYY')}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={redeem.total}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getRedeem, getSetting })(AcceptedRedeemTable);
